import './ReverseHeader.scss';

import { Typography } from '@modulor/react';
import type { FC, ReactNode } from 'react';
import { getPathPrefix } from 'utils';

interface ReverseHeaderProps {
  title: ReactNode;
  subtitle: ReactNode;
  children?: ReactNode;
}

// shared header of the full and partial reverse popups (Figma 23669-20409)
export const ReverseHeader: FC<ReverseHeaderProps> = ({ title, subtitle, children }) => (
  <div className="reverse-header">
    <img alt="" className="reverse-header__image" src={`${getPathPrefix()}/assets/withdrawal-reject-money-bag.webp`} />
    <div className="reverse-header__text">
      <Typography variant="title-1-semibold" tag="h1" className="reverse-header__title">
        {title}
      </Typography>
      <Typography variant="subhead-regular" tag="p" className="reverse-header__subtitle">
        {subtitle}
      </Typography>
    </div>
    {children}
  </div>
);
